import { connect } from 'react-redux';
import { compose } from 'redux';
import { orientationChanged } from '../actionCreators';
import DeviceOrientation from '../components/DeviceOrientation';
import onlyIf from '../hocs/onlyIf';
import { shouldDetectDeviceOrientation } from '../selectors/deviceOrientation';
function mapStateToProps(state) {
    return {
        shouldDetectDeviceOrientation: shouldDetectDeviceOrientation(state),
    };
}
function mapDispatchToProps(dispatch) {
    return {
        orientationChanged: function (orientation) {
            dispatch(orientationChanged(orientation));
        },
    };
}
export default compose(connect(mapStateToProps, mapDispatchToProps), onlyIf(function (props) { return props.shouldDetectDeviceOrientation; }))(DeviceOrientation);
